
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#2FB95E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.252 11.735l1.294 1.293h-.001l-1.293 1.58c3.163 3.304 3.163 8.619 0 12.066-3.307 3.448-8.912 3.591-12.506.287-3.45-3.304-3.594-8.906-.287-12.497l-1.293-1.293 1.293-1.293 1.294 1.293a8.185 8.185 0 014.167-1.58V9.724h-1.724V8h5.318v1.724H19.79v1.723c1.438.144 2.876.719 4.17 1.58l1.293-1.292zM12.315 20.21a6.44 6.44 0 006.469 6.464c3.594 0 6.468-2.73 6.468-6.464a6.44 6.44 0 00-6.468-6.464 6.44 6.44 0 00-6.469 6.464zm6.469.143v-4.165a4.17 4.17 0 014.168 4.165 4.17 4.17 0 01-8.337 0h4.168z","fill":"#fff"}})])
          )
        }
      }
    